<!--
  ~ Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
@if (filters().length > 0) {
  <div class="search-criteria">
    <div class="search-criteria-title">&nbsp; Active Search Criteria</div>
    @for (f of filters(); track f.key) {
      <span class="search-criteria-element" [class.search-criteria-element-locked]="isLocked(f.key)">
        <b>{{ f.key }}:</b> {{ f.value.join(', ') }}
        <button type="button" (click)="remove.emit(f.key)" class="fa fa-times"
                [disabled]="isLocked(f.key)"
                [title]="isLocked(f.key) ? 'Required for read-only users' : 'Clear filter'"></button>
      </span>
    }
    @if (removableCount() >= 2) {
      <button type="button" class="search-criteria-element search-criteria-element-remove-all"
              (click)="removeAll.emit()" title="Clear all search filters">
        <i class="fa fa-times"></i>
        Clear All
      </button>
    }
  </div>
}
